import { render, staticRenderFns } from "./Tipo_Identidad.vue?vue&type=template&id=9df4fa7a&scoped=true"
import script from "./Tipo_Identidad.vue?vue&type=script&lang=js"
export * from "./Tipo_Identidad.vue?vue&type=script&lang=js"
import style0 from "./Tipo_Identidad.vue?vue&type=style&index=0&id=9df4fa7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df4fa7a",
  null
  
)

export default component.exports